import type {PropsWithChildren} from 'react';
import {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {BoxStyleProps} from 'components/types';
import {Layout} from '../layout';

const CardNavigationHeaderName = 'CardNavigationHeaderName';

type Props = {
  minHeight?: string | number;
};

const CardNavigationHeader: React.FC<PropsWithChildren<Props>> = ({
  minHeight = '40px',
  children,
}) => {
  const {colors} = useTheme();
  const sx = useMemo(
    (): BoxStyleProps => ({
      background: colors.beige,
      px: 1,
    }),
    [colors],
  );

  return (
    <Layout horizontal minHeight={minHeight} sx={sx}>
      {children}
    </Layout>
  );
};

CardNavigationHeader.displayName = CardNavigationHeaderName;

export {CardNavigationHeader, CardNavigationHeaderName};
